export * from './Authentication.js';
export * from './Connect.js';
export * from './EndpointErrors.js';
export { ActionOnLostSubscription, FluxConnection, State } from './FluxConnection.js';

// @ts-expect-error: esbuild injection
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
((feature, vaadinObj = (globalThis.Vaadin ??= {})) => {
  vaadinObj.registrations ??= [];
  vaadinObj.registrations.push({
    is: feature ? `@vaadin/hilla-frontend/${feature}` : '@vaadin/hilla-frontend',
    version: '24.8.6',
  });
})();
